// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"027ad8b1","589":"4ad64c4c","823":"6723fc89"}[chunkId] + ".chunk.js";
};